module.exports = __webpack_public_path__ + "static/img/honour6.847296b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/honour6.png
// module id = 6spN
// module chunks = 1